"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = exports.CanvasEngine = void 0;
const Canvas_1 = require("./implementation/Canvas");
Object.defineProperty(exports, "Canvas", { enumerable: true, get: function () { return Canvas_1.Canvas; } });
const CanvasEngine_1 = require("./implementation/CanvasEngine");
Object.defineProperty(exports, "CanvasEngine", { enumerable: true, get: function () { return CanvasEngine_1.CanvasEngine; } });
//# sourceMappingURL=index.js.map